import { APIReponseError } from '..'
import { graphQLBase } from '..'

const FilesAPI = {
  fetchConfluenceSpaces: graphQLBase(
    `query getConfluenceSpaces {
      getConfluenceSpaces {
        name
        key
      }
    }
    `
  ),
  importConfluenceSpace: graphQLBase(
    `mutation importDocumentsFromConfluenceSpace($input: ImportDocumentsFromConfluenceSpaceInput!
    ) {
      importDocumentsFromConfluenceSpace(input: $input)
    }
    `
  ),
  uploadGoogleDriveFiles: graphQLBase(
    `mutation UploadGoogleDriveFiles($input: ImportFilesFromGoogleDriveInput!) {
      importGoogleDriveFilesFromIdList(input: $input)
    }
    `
  ),
  uploadTextFiles: graphQLBase(`
    mutation UploadTextualFiles($input: ImportFilesFromFileUrlInput!) {
      importFilesFromUrlList(input: $input)
    }
  `),
  uploadFile: (
    { apiEndpoint, apiToken },
    { file, folder = 'files', isTemporary = false }
  ) => {
    const type = file.type || 'application/octet-stream'
    const input = {
      name: escape(file.name),
      type,
      folder,
      isTemporary,
    }

    return graphQLBase(
      `query getUploadUrl($input: GetUploadUrlInput!) {
      getUploadUrl(input: $input) {
        readUrl
        uploadUrl
      }
    }`,
      ({ getUploadUrl }) => getUploadUrl
    )({ apiEndpoint, apiToken }, { input }).then(({ uploadUrl, readUrl }) =>
      fetch(uploadUrl, {
        method: 'PUT',
        body: file,
        headers: {
          'Content-Type': type,
        },
      }).then(
        function onUploadSuccess(response) {
          return readUrl
        },
        function onUploadFailure(response) {
          throw new APIReponseError('Upload failed', response)
        }
      )
    )
  },
}

export default FilesAPI
